<template>
  <a-dropdown>
    <a-badge :count="counts?.unread">
      <div class="action-button">
        <a-icon width="24" height="24" icon="ant-design:notification-outlined" />
      </div>
    </a-badge>
    <div class="wrapper" slot="overlay">
      <div class="alert-wrapper" :style="{ color: '#ef4444' }" @click="handleAlertRoute('forbid_work')">
        <div class="alert-item" :style="{ backgroundColor: 'rgb(255, 242, 240)', color: '#ef4444' }">
          {{ counts?.critical ? (counts?.critical < 99 ? counts?.critical : '99+') : 0 }}
        </div>
        Critical
      </div>

      <div class="alert-wrapper" :style="{ color: '#f59e0b' }" @click="handleAlertRoute('warning')">
        <div class="alert-item" :style="{ backgroundColor: 'rgb(255, 251, 240)', color: '#f59e0b' }">
          {{ counts?.warning ? (counts?.warning < 99 ? counts?.warning : '99+') : 0 }}
        </div>
        Warning
      </div>

      <div class="alert-wrapper" :style="{ color: '#10b981' }" @click="handleAlertRoute('new')">
        <div class="alert-item" :style="{ backgroundColor: '#D7F0E6', color: '#10b981' }">
          {{ counts?.unread ? (counts?.unread < 99 ? counts?.unread : '99+') : 0 }}
        </div>
        New
      </div>

      <div class="alert-wrapper" :style="{ color: '#999999' }" @click="handleAlertRoute('total')">
        <div class="alert-item" :style="{ backgroundColor: '#EEEEEE', color: '#999999' }">
          {{ counts?.total ? (counts?.total < 99 ? counts?.total : '99+') : 0 }}
        </div>

        Total
      </div>
    </div>
  </a-dropdown>
</template>
<script>
import { Badge, Dropdown, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions, mapState } = createNamespacedHelpers('alerts')

export default {
  components: {
    'a-badge': Badge,
    'a-dropdown': Dropdown
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      counts: state => state.alertsCount
    })
  },
  methods: {
    ...mapActions(['getAlertsCount']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    handleAlertRoute(key) {
      this.$router
        .push({
          path: '/alert-store',
          query: {
            severity: ['forbid_work', 'warning'].includes(key) ? key : undefined,
            route: key
          }
        })
        .catch(() => {})
    },

    async fetchAlertsCount() {
      try {
        await this.getAlertsCount()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchAlertsCount()

    this.intervalId = setInterval(() => {
      this.fetchAlertsCount()
    }, 60000)
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }
}
</script>

<style scoped>
.wrapper {
  border-radius: 8px;
  gap: 8px;
  display: flex;
  justify-content: space-between;
  background-color: var(--bg-component);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 8px;
}

.alert-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
}

.alert-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
}
</style>
